export type ScoreLevel = 'excellent' | 'good' | 'fair' | 'poor';

export function getScoreLevel(score: number): ScoreLevel {
  if (score >= 90) return 'excellent';
  if (score >= 75) return 'good';
  if (score >= 60) return 'fair';
  return 'poor';
}

export function getScoreClass(score: number): string {
  return `score-${getScoreLevel(score)}`;
}
